import ko from 'knockout';
import $ from 'jquery';
import _ from 'lodash';
import FormatterCommon from './formatter-common';
import FlexipanelCommon from '../helpers/flexipanel-common';

function KPICellFormatter(params, observableOptions, dataSources, panelId) {
    var self = this;

    self.panelId = panelId;
    self.observableOptions = observableOptions;
    self.dataSources = dataSources;

    self.sourcetype = _.get(params, 'type', '');

    self.datapresorted = _.get(params, 'datapresorted', false);
    self.dataprepaged = _.get(params, 'dataprepaged', false);

    self.observableParams = dataSources[0].observableParams;
    self.observableFormattedData = ko.observable();

    self.subscriptions = [];
}

function ComposeData(metadata, sourcelist) {
    var result = {};

    result.kpi = getKpiValues(sourcelist);
    result.metadata = metadata;

    return result;
}

function getKpiValues(data) {
    var kpi = {};

    if (_.isEmpty(_.get(data, 'Table'))) {
        return { abbreviatedValue: '-', value: '-' };
    }

    var rawValue = _.get(data, 'Table[0].aggregateFact', '0');
    kpi.abbreviatedValue = FormatterCommon.getFormattedNumber(rawValue, true /*useAbbreviation*/);
    kpi.value = FormatterCommon.getFormattedNumber(rawValue, false /*useAbbreviation*/);

    if (!_.isEmpty(data.Table1)) {
        var kpiChange = {};

        var oldValue = _.toInteger(_.get(data, 'Table1[0].aggregateFact', '0'));
        var kpiChangeValue = _.round((_.toInteger(rawValue) - oldValue) * 100 / (oldValue || 1));

        kpiChange.changeindicator = kpiChangeValue < 0 ? "<i class='flaticon-sort37'></i>" : kpiChangeValue > 0 ? "<i class='flaticon-sort33'></i>" : "--";

        var color = kpiChangeValue < 0 ? 'text-red' : kpiChangeValue > 0 ? 'text-green' : 'text-gray';

        kpiChange.changeindicatorstyle = 'kpicellchangeindicatorstyle ' + color;
        kpiChange.changevaluestyle = 'kpicellchangevaluestyle ' + color;
        kpiChange.value = kpiChangeValue + '%';

        kpi.change = kpiChange;
    }

    return kpi;
}

KPICellFormatter.prototype.RefreshData = function () {
    var self = this;

    if (!_.isEmpty(ko.unwrap(self.observableParams))) {
        self.sourceList = self.dataRepository
            .getDictionaryValue(self.dataRepository.FlexQueryResultDictionary, self.observableParams());
    }

    var options = ko.unwrap(self.observableOptions);

    if (_.isEmpty(options.panelHeader)) {
        options.panelHeader = FlexipanelCommon.getMetricNameByKey(self.metadata.Table, _.first(options.selectedMetricColumnNames));
        if (options.panelHeader) {
            self.observableOptions(options);
        }
    }

    if (!self.sourceList) {
        return self.observableFormattedData({
            metadata: self.metadata,
            rows: []
        });
    }

    self.observableFormattedData(ComposeData(
        self.metadata,
        self.sourceList,
        options));
};

KPICellFormatter.prototype.DataUpdated = function () {
    var self = this;
    self.RefreshData();
};

KPICellFormatter.prototype.OptionsUpdated = function () {
    var self = this;
    self.RefreshData();
};

KPICellFormatter.prototype.initialize = function (dataRepository) {
    var self = this;

    self.dataRepository = dataRepository;
    self.metadata = self.dataRepository.flexQueryMetaData();

    self.subscriptions.push(self.dataRepository.FlexQueryResultDictionary.subscribe(function (newval) {
        if (self.dataRepository.lastPanelId === self.panelId) {
            self.DataUpdated();
        }
    }));

    self.subscriptions.push(self.dataRepository.flexQueryMetaData.subscribe(function (newval) {
        self.metadata = self.dataRepository.flexQueryMetaData();
        self.observableFormattedData({
            metadata: self.metadata,
            rows: []
        });
    }));

    self.RefreshData();
};

KPICellFormatter.prototype.getObservableData = function () {
    var self = this;

    return self.observableFormattedData;
};

KPICellFormatter.prototype.dispose = function () {
    var self = this;
    self.subscriptions.forEach(function (sub) {
        sub.dispose();
    });
};

export default KPICellFormatter;
